/* Keep the initial in-stock default separate from an explicit shopper choice. */
(() => {
  const availability = 'filter.v.availability';
  const allStock = 'stock_filter';
  const collectionKey = (url) => {
    const match = url.pathname.match(/^(.*\/collections\/[^/]+)/);
    return match ? `collection-stock:${match[1]}` : null;
  };

  function remember(url) {
    const key = collectionKey(url);
    if (!key) return;
    try {
      sessionStorage.setItem(key, JSON.stringify(url.searchParams.getAll(availability)));
    } catch (_) {
      // The URL also carries the choice when browser storage is unavailable.
    }
  }

  function prepare(url) {
    if (!collectionKey(url)) return url;
    if (url.searchParams.has(availability)) url.searchParams.delete(allStock);
    else url.searchParams.set(allStock, 'all');
    remember(url);
    return url;
  }

  function updatePagination(url = new URL(window.location.href)) {
    if (!collectionKey(url)) return;
    document.querySelectorAll('#ProductGridContainer .pagination a[href]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      target.searchParams.delete(availability);
      target.searchParams.delete(allStock);
      const values = url.searchParams.getAll(availability);
      values.forEach((value) => target.searchParams.append(availability, value));
      if (!values.length) target.searchParams.set(allStock, 'all');
      link.href = target.href;
    });
  }

  window.CollectionStockFilter = { prepare, updatePagination };
  const url = new URL(window.location.href);
  const key = collectionKey(url);
  if (!key) return;

  if (url.searchParams.has(availability) || url.searchParams.get(allStock) === 'all') {
    remember(url);
  } else if (url.searchParams.has('page')) {
    // A paginated URL already describes a result set; never add a default here.
    prepare(url);
    history.replaceState(history.state, '', url.href);
  } else {
    let values = ['1'];
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (Array.isArray(saved) && saved.every((value) => value === '0' || value === '1')) values = saved;
    } catch (_) {
      // First visits still default to in stock if storage is unavailable.
    }
    if (values.length) {
      values.forEach((value) => url.searchParams.append(availability, value));
      remember(url);
      window.location.replace(url.href);
      return;
    }
    prepare(url);
    history.replaceState(history.state, '', url.href);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updatePagination(), { once: true });
  } else updatePagination();
})();
